import { useOrbit, type TabId } from '../store'
import { MessageCircle, Clock, CalendarDays, Globe, BookOpen, GraduationCap } from 'lucide-react'
import { haptic } from '../telegram'

const TABS: { id: TabId; label: string; Icon: typeof MessageCircle }[] = [
  { id: 'home', label: 'Умный дом', Icon: Globe },
  { id: 'chat', label: 'Чат', Icon: MessageCircle },
  { id: 'clock', label: 'Часы', Icon: Clock },
  { id: 'calendar', label: 'Календарь', Icon: CalendarDays },
  { id: 'content', label: 'Контент', Icon: BookOpen },
  { id: 'education', label: 'Образование', Icon: GraduationCap },
  { id: 'browser', label: 'Браузер', Icon: Globe }
]

export function TabBar() {
  const { tab, setTab } = useOrbit()

  return (
    <nav
      className="no-select tap-active flex overflow-x-auto border-t border-border-primary bg-bg-secondary"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      {TABS.map(({ id, label, Icon }) => {
        const active = tab === id
        return (
          <button
            key={id}
            onClick={() => {
              haptic('light')
              setTab(id)
            }}
            className="flex min-w-[72px] flex-1 flex-col items-center gap-0.5 px-1 py-2.5 text-[10px] transition-colors"
            style={{ color: active ? 'var(--color-accent-primary)' : 'var(--color-text-muted)' }}
          >
            <Icon size={22} strokeWidth={active ? 2.4 : 1.8} />
            <span className={active ? 'font-medium' : ''}>{label}</span>
          </button>
        )
      })}
    </nav>
  )
}
